import reducerRegistry from '@comeon/reducer-registry';

// Constants
const REDUCER_NAME = 'account/phoneVerificationModal';
const ACTION_PREFIX = '@komigen/account/phoneVerificationModal/';

// Selectors
export const selectVerificationModalIsOpen = state => state[REDUCER_NAME].verificationModalIsOpen;

// Actions
export const VERIFICATION_MODAL_OPENED = `${ACTION_PREFIX}VERIFICATION_MODAL_OPENED`;
export const VERIFICATION_MODAL_HIDDEN = `${ACTION_PREFIX}VERIFICATION_MODAL_HIDDEN`;

// ActionCreators
export const showPhoneVerificationModal = () => ({
	type: VERIFICATION_MODAL_OPENED
});

export const closePhoneVerificationModal = () => ({
	type: VERIFICATION_MODAL_HIDDEN
});

// Reducer
const initialState = {
	verificationModalIsOpen: false
};

const reducer = (state = initialState, { type }) => {
	switch (type) {
		case VERIFICATION_MODAL_OPENED:
			return { ...state, verificationModalIsOpen: true };
		case VERIFICATION_MODAL_HIDDEN:
			return { ...state, verificationModalIsOpen: false };
		default:
			return state;
	}
};

reducerRegistry.register(REDUCER_NAME, reducer);
export default reducer;
